// This JavaScript file is created by Cision for our insider module.
// This is the first version of this file so far.

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.dividend = !cision.websolution.settings.dividend ? {}: function ($) {

    var settings = cision.websolution.settings.general;
    var accessKey = cision.websolution.settings.dividend.accessKey;

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var renderToGraph = function (objChart, options) {

        if (options) {
            $.extend(settings, options);
        }

        if (!accessKey) {
            console.log("You must provider your access key [dividend module].");
            return;
        }
        var url = generateUrl('Ticker/' + accessKey + '/Dividend');
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                type: settings.dividendType || 'Annual',
                startDate: settings.startDate,
                endDate: settings.endDate
            }
        })
        .done(function (rawData) {
            // TODO: emit an error when no instruments with data found
            var objPackage = rawData.Instruments[0];

            var pointsDividends = [];
            $.each(objPackage.Dividends, function (idx, objDividend) {
                pointsDividends.push({
                    x: moment(objDividend.EventDate).format('X') * 1000,
                    title: settings.dividendsTitle,
                    DividendTransaction: objDividend
                });
            });

            var objInstrument = { UniqueKey: settings.dividendsUniqueKey };
            var objChartSeries = {
                id: objInstrument.UniqueKey,
                name: 'DIVIDENDS',
                type: 'flags',
                data: pointsDividends,
                color: settings.graphColor ,

                // Extra data
                objOriginal: objInstrument,

                visible: true
            };

            objChartSeries.tooltip = {
                //shared: true,
                useHTML: true,
                //headerFormat: '<div><small>{point.key}</small></div><br/>',
                pointFormat: '<strong>{point.DividendTransaction.Amount}</strong>'
            };

            objChart.addSeries(objChartSeries);
        })
        .fail(function () {
            console.log('Could not retrieve dividend data');
        })
        .always(function () {

        });
    };

    return {
        renderToGraph: renderToGraph
    };
} (jQuery);